import { useMemo } from "react";

import { useSelector } from "react-redux";

import { selectAllUniqueWebsites } from "../store/selectors";

function useUntrackedDomainsCount(domains: readonly string[]): number {
    const uniqueWebsitesTracked = useSelector(selectAllUniqueWebsites);

    return useMemo(() => {
        const trackedWebsitesSet = new Set(uniqueWebsitesTracked);

        return [...new Set(domains)].filter((domain) => !trackedWebsitesSet.has(domain)).length;
    }, [domains, uniqueWebsitesTracked]);
}

export default useUntrackedDomainsCount;
